import script from "./FundedContract.vue?vue&type=script&setup=true&lang=js"
export * from "./FundedContract.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__